<template>
  <div class="w-full max-w-xl py-20 bg-white flex flex-col space-y-20">
    <AutoRewardsBasket
      v-if="step === '1'"
      @addAddress="goToStep('2.a.1')"
      @addEmail="goToStep('2.b.1')"
    />

    <AlternateAddressForm
      v-if="step === '2.a.1'"
      :exitModal="exitModal"
      @cancel="onCancel"
      @continue="onAddressCreate"
    />
    <AlternateEmailForm
      v-if="step === '2.b.1'"
      :exitModal="exitModal"
      @cancel="onCancel"
      @continue="onEmailCreate"
    />

    <RequestMfaForm
      v-if="step === '3.1'"
      @cancel="onCancel"
      @continue="goToStep('3.2')"
    />
    <VerifyMfaForm
      v-if="step === '3.2'"
      @cancel="onCancel"
      @continue="onVerificationSuccess"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import AlternateAddressForm from '@components/views/rewards/delivery-destination/AlternateAddressForm'
import AlternateEmailForm from '@components/views/rewards/delivery-destination/AlternateEmailForm'
import RequestMfaForm from '@components/views/rewards/delivery-destination/RequestMfaForm'
import VerifyMfaForm from '@components/views/rewards/delivery-destination/VerifyMfaForm'
import AutoRewardsBasket from '@components/views/rewards/AutoRewardsBasket'

export default {
  name: 'AutoRewardsConfirmation',
  components: {
    AlternateAddressForm,
    AlternateEmailForm,
    AutoRewardsBasket,
    RequestMfaForm,
    VerifyMfaForm,
  },
  data() {
    return {
      historyStack: [],
      step: '1',
      unverifiedDeliveryDestination: null,
      exitModal: {
        exitTitle: this.$t('edit_account.exit_title'),
        exitDescription: this.$t('edit_account.exit_description'),
        exitConfirm: this.$t('edit_account.exit_confirm'),
        exitCancel: this.$t('edit_account.exit_cancel'),
      },
    }
  },
  computed: {
    ...mapGetters('member', ['canCreateDeliveryDestinations', 'mfaType']),
    ...mapState('member', ['elevatedRoleToken']),
  },
  watch: {
    historyStack: {
      deep: true,
      handler: () => {
        /* NO-OP: needed to avoid NPE */
      },
    },
  },
  methods: {
    ...mapActions('member', ['createDeliveryDestination']),
    ...mapActions('rewards', ['setDeliveryDestinations']),
    maybeCreateDeliveryDestination(deliveryDestination) {
      if (this.canCreateDeliveryDestinations) {
        const request = {
          ...deliveryDestination,
          elevatedRoleToken: this.elevatedRoleToken,
        }

        this.createDeliveryDestination(request)
          .then(({ addresses, emails }) => {
            this.setDeliveryDestinations({
              physical: addresses?.[0]?.id,
              digital: emails?.[0]?.id,
            })
            this.goToStart()
          })
          .catch((...args) => {
            console.error(
              'Unexpected error in AutoRewardsConfirmation#maybeCreateDeliveryDestination',
              ...args
            )
          })
      } else {
        this.unverifiedDeliveryDestination = deliveryDestination
        this.goToStep('3.1')
      }
    },
    onAddressCreate(payload) {
      const deliveryDestination = {
        deliveryForm: 'physical',
        shipping: payload,
      }
      this.maybeCreateDeliveryDestination(deliveryDestination)
    },
    onEmailCreate(payload) {
      const deliveryDestination = { deliveryForm: 'digital', shipping: payload }
      this.maybeCreateDeliveryDestination(deliveryDestination)
    },
    onVerificationSuccess() {
      if (!this.unverifiedDeliveryDestination) return
      this.maybeCreateDeliveryDestination(this.unverifiedDeliveryDestination)
    },
    goToStart() {
      this.step = '1'
      this.historyStack = []
    },
    goToStep(nextStep) {
      this.historyStack.push(this.step)
      this.step = nextStep
    },
    onCancel() {
      const previousStep = this.historyStack.pop()
      if (!!previousStep) {
        this.step = previousStep
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>
